<template>
  <div class="home_page" v-loading="reqLoading">
    <!-- 搜索组件 -->
    <CommonSearch
      @postSearchParams="postSearchParams"
      :needForegroundCategoryId="true"
      ref="commonSearchRef"
      pageName="goodCategoryList"
      v-if="isCommonSearchShow"
    ></CommonSearch>
    <!-- 商品组件 -->
    <good-list
      :goodList="goodList"
      :page="page"
      :total="total"
      @refushDataList="refushDataList"
    >
    </good-list>
    <div class="no_show_message" v-show="!total">
      <img src="@/assets/img/good/noGood.png" :alt="$t('product.noGoods')" />
      <div>{{ $t("product.noGoods") }}</div>
    </div>
    <!-- 回到顶部 -->
    <!-- <backToTop /> -->
  </div>
</template>
<script>
import GoodList from "./goodListScrollNew.vue";
import CommonSearch from "./commonSearch.vue";
import SelectedChild from "./selectedChild.vue";

export default {
  data() {
    return {
      reqLoading: false,
      goodList: [],
      page: 1,
      total: 0,
      searchParams: {},
      isCommonSearchShow:true
    };
  },
  components: {
    GoodList,
    CommonSearch,
    SelectedChild,

    // backToTop
  },
  computed: {},
  watch: {
    "$route.query": {
      handler: "reloadListHandle",
      immediate: false,
    },
  },
  mounted() {
  },
  methods: {
    reloadListHandle() {
  
      this.goodList = [];
      this.page = 1;
      this.total = 0;
      this.searchParams = {};
      // this.$refs.commonSearchRef.$forceUpdate()
      this.isCommonSearchShow = false
      this.$nextTick(()=>{
        this.isCommonSearchShow = true
      })
    },
    postSearchParams(params) {
      this.searchParams = params;
      this.refushDataList(1);
    },
    // 查询商品列表及数据条数
    refushDataList(page = this.page, reset = true) {
      if (this.reqLoading) {
        return false;
      }
      this.reqLoading = true;
      this.page = page;
      if (page === 1) {
        this.goodList = [];
        this.total = 0;
        this.attributePage = 1;
      }
      // /front/cross/commodity-user/web/spu-list 老spu列表接口
      this.$http
        .post(`/front/commodity-user/web/group-list`, {
          limit: 20,
          page: page,
          ...this.searchParams,
          // search: this.$route.query.search || "", // 搜索内容
          // brandIdList: this.brandIdList, // 品牌主键列表
          // seriesNameList: this.seriesNameList, // 系列主键列表
          // attributeValueIdList: this.attributeValueIdList, // 属性值主键列表
          // foregroundCategoryId: this.foregroundCategoryId, // 前台类目主键
          // salesDesc: this.salesDesc,
          // priceDesc: this.priceDesc,
          // popularityDesc: this.popularityDesc
        })
        .then(({ data: res }) => {
          this.reqLoading = false;
          if (res.code !== 0) {
            this.goodList = [];
            this.total = 0;
            return false;
          }
          if (reset) {
            // this.goodList.push(...(list || []));
            this.goodList.push(...(res.data.dataList || []));
          } else {
            // this.goodList = list;
            this.goodList = res.data.dataList || [];
          }
          this.total = res.data.count;
        })
        .catch(() => {
          this.reqLoading = false;
          this.goodList = [];
          this.total = 0;
        });
    },
  },
};
</script>
<style lang="scss" scoped></style>
